export enum Role {
  artist = 'Artist',
  club = 'ClubOwner',
  admin = 'Admin'
}

export enum ArtistJobs {
  Hostess = 'Hostess',
  GoGo = 'GoGo',
  Strip = 'Strip'
}

export enum ArtistProfileStatus {
  LookingForWork = 'LookingForWork',
  OnContract = 'OnContract',
  FinishingContract = 'FinishingContract',
  OnVacation = 'OnVacation',
  HiddenFromSearch = 'HiddenFromSearch'
}

export type ArtistLanguageDto = {
  name: string;
  level: ArtistLanguageLevels;
};

export enum ArtistLanguageLevels {
  A1 = 'A1',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2',
  C1 = 'C1',
  C2 = 'C2',
  Native = 'Native'
}

export type ErrorResponse = {
  Type: string;
  Title: string;
  Status: number;
  Detail: string;
  Instance: string;
  Extensions: object;
  Errors?: {
    [key: string]: [string];
  };
};

export type NotificationDto = {
  createdAt: string;
  isRead: false;
  message: string;
  notificationId: number;
  profileId: number;
  profileType: Role;
  artistProfileId: number;
  clubProfileId: number;
  workRequestId: number | null;
  workInviteId: number | null;
};

export type WorkItems = WorkRequestItemDto | WorkInviteItemDto;

export enum WorkItemTypes {
  Request = 'Request',
  Invite = 'Invite'
}

export type WorkItemDto = {
  approvedByArtist: string;
  approvedByClub: string;
  arrivalConfirmed: boolean;
  artistName: string;
  artistPhoto: string;
  artistProfileId: number;
  artistRequestedEndDate: boolean;
  clubName: string;
  clubPhoto: string;
  clubProfileId: number;
  createdAt: string;
  endDate: string;
  expiration: string;
  isArchived: boolean;
  jobRole: ArtistJobs;
  newEndDate: string;
  startDate: string;
  status: WorkItemStatus;
  ticketCreditation: boolean;
  updatedAt: string;
  workItemId: number;
  workItemType: WorkItemTypes;
};

export type WorkRequestItemDto = {
  artistName: string;
  artistPhoto: string;
  clubName: string;
  clubPhoto: string;
  workRequestId: number;
  artistProfileId: number;
  newEndDate: string | null;
  approvedByArtist?: boolean;
  approvedByClub?: boolean;
  clubProfileId: number;
  jobRole: ArtistJobs;
  startDate: string;
  endDate: string;
  expiration: string;
  status: WorkItemStatus;
  createdAt: string;
  updatedAt: string;
  isArchived: boolean;
  ticketCreditation: boolean;
  arrivalConfirmed: boolean;
  artistRequestedEndDate: boolean;
};

export type WorkInviteItemDto = {
  workItemType: WorkItemTypes;
  workItemId: number;
  workInviteId: number;
  artistProfileId: number;
  clubProfileId: number;
  jobRole: ArtistJobs;
  startDate: string;
  endDate: string;
  expiration: string;
  newEndDate: string | null;
  approvedByArtist?: boolean;
  approvedByClub?: boolean;
  status: WorkItemStatus;
  createdAt: string;
  updatedAt: string;
  isArchived: boolean;
  ticketCreditation: boolean;
  artistName: string;
  artistPhoto: string;
  clubName: string;
  clubPhoto: string;
  arrivalConfirmed: boolean;
  artistRequestedEndDate: boolean;
};

export type WorkDto = {
  artistProfileId: number;
  clubProfileId: number;
  jobRole: ArtistJobs;
  startDate: string;
  endDate: string;
  ticketCreditation: boolean;
};

export enum WorkItemStatus {
  Pending = 'Pending',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  Withdrawn = 'Withdrawn',
  Expired = 'Expired',
  ContractOngoing = 'ContractOngoing',
  ContractRequestedEndDate = 'ContractRequestedEndDate',
  ClubSetEndDate = 'ClubSetEndDate',
  ContractCompleted = 'ContractCompleted',
  Cancelled = 'Cancelled'
}

export type ArtistInfoDto = {
  firstName: string;
  lastName: string;
  birthDate: string;
  countryOfResidence: string;
  phoneNumber: string;
  citizenships: string[];
  isLookingForStripVacancy: boolean;
  isLookingForGoGoVacancy: boolean;
  isLookingForHostessVacancy: boolean;
};

export type ArtistWorkHistory = {
  clubName: string;
  clubCountry: string;
  startDate: string;
  endDate: string | null;
  untilNow: boolean;
  jobRole: ArtistJobs;
};

export type ArtistWorkHistoryDto = {
  hasWorkingExperience: boolean;
  workHistory: ArtistWorkHistory[] | [];
};

export type ArtistLanguage = {
  name: string;
  level: ArtistLanguageLevels;
};

export type ArtistParametersDto = {
  height: number;
  weight: number;
  chest: number;
  waist: number;
  hips: number;
};

export type PaginatedResponse<Data> = {
  items: Data;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
};

export enum ArtistPhotoTag {
  FaceWithMakeup = 'FaceWithMakeup',
  FaceNoMakeup = 'FaceNoMakeup',
  FreePose = 'FreePose',
  FullBodyOnHeels = 'FullBodyOnHeels',
  LingerieOrSwimsuit = 'LingerieOrSwimsuit',
  ProfilePhoto = 'Profile'
}

export enum ClubPhotoTag {
  HallNoGuests = 'HallNoGuests',
  HallWithGuests = 'HallWithGuests',
  Housing = 'Housing',
  WorkingHours = 'WorkingHours',
  PrivateRooms = 'PrivateRooms',
  Scene = 'Scene',
  ProfilePhoto = 'Profile'
}
export enum ClubVideoTag {
  WorkingHours = 'WorkingHours',
  ClubTour = 'ClubTour',
  EventVideo = 'EventVideo'
}

export type ArtistPhotoDto = {
  file: File | null;
  title: string;
  description: string;
  tag: ArtistPhotoTag;
  ArtistProfileId: string;
  IsProfile: boolean;
};

export type ClubPhotoDto = {
  file: File | null;
  title: string;
  description: string;
  tag: ClubPhotoTag;
  ClubProfileId: string;
  IsProfile: boolean;
};

export type ParametersDto = {
  height: number;
};

export type ProfileProgressDto = {
  personalInfoCompletion: number;
  workHistoryCompletion: number;
  languageMasteryCompletion: number;
  parametersCompletion: number;
  photosCompletion: number;
  videosCompletion: number;
  aboutCompletion: number;
  totalCompletion: number;
};

export type ClubProgressDto = {
  clubInfoCompletion: number;
  contractTermsCompletion: number;
  housingConditionsCompletion: number;
  paymentsCompletion: number;
  penaltiesCompletion: number;
  photosCompletion: number;
  totalCompletion: number;
  videosCompletion: number;
  workScheduleCompletion: number;
  workingConditionsCompletion: number;
};

export type SearchClubItemDto = {
  clubProfileId: number;
  name: string;
  address: string;
  country: string;
  isHiring: boolean;
  isStripVacancyOpen: boolean;
  isGoGoVacancyOpen: boolean;
  isHostessVacancyOpen: boolean;
  searchPhoto: PhotoItemDto;
  avatarPhoto: PhotoItemDto;
};

export type SearchArtistItemDto = {
  artistProfileId: number;
  firstName: string;
  lastName: string;
  countryOfResidence: string;
  hasWorkingExperience: boolean;
  isLookingForStripVacancy: boolean;
  isLookingForGoGoVacancy: boolean;
  isLookingForHostessVacancy: boolean;
  profileStatus: ArtistProfileStatus;
  searchPhoto: PhotoItemDto;
  avatarPhoto: PhotoItemDto;
};

export type SearchParams = {
  countries?: string;
  pageNumber?: string;
  pageSize?: string;
  includeHidden?: string;
};

export enum ArtistVideoTag {
  Walk = 'Walk',
  StripDance = 'StripDance'
}

export type ArtistVideoDto = {
  file: File | null;
  title: string;
  description: string;
  tag: ArtistVideoTag;
  ArtistProfileId: string;
};

export type ClubVideoDto = {
  file: File | null;
  title: string;
  description: string;
  tag: ClubVideoTag;
  ArtistProfileId: string;
};

export type VideoItemDto = {
  id: number;
  title: string;
  description: string;
  tag: ClubVideoTag | ArtistVideoTag;
  isMandatory: boolean;
  filePath: string;
  thumbnailPath: string;
};

export type ClubInfoDto = {
  name: string;
  phone: string;
  address: string;
  currency: string;
  country: string;
  isHiring?: boolean;
  currencySymbol: string;
  isStripVacancyOpen: boolean;
  isGoGoVacancyOpen: boolean;
  isHostessVacancyOpen: boolean;
};

export type ClubInfo = {
  name: string;
  phone: string;
  address: string;
  currency: string;
  country: string;
  isHiring?: boolean;
  currencySymbol: string;
  isStripVacancyOpen: boolean;
  isGoGoVacancyOpen: boolean;
  isHostessVacancyOpen: boolean;
  avatarPhoto: PhotoItemDto | null;
  clubProfileId: number | null;
  searchPhoto: PhotoItemDto | null;
};

export enum DayOfWeek {
  Sunday = 'Sunday',
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday'
}

export type DayScheduleItem = {
  day: DayOfWeek;
  startHour: string;
  closeHour: string;
  isClosed: boolean;
  isOpen24Hours: boolean;
};

export enum FlightPaymentType {
  Club = 'Club',
  Artis = 'Artist',
  Credit = 'Credit',
  Agreement = 'Agreement',
  Compensation = 'Compensation'
}

export type ContractTermsDto = {
  minContractDurationWeeks: number;
  artistWorkSchedule: string;
  flightPaymentType: FlightPaymentType;
  compensationForOneMonth: number;
  compensationForTwoMonths: number;
  compensationForThreeMonths: number;
  freeReturnTicketAfterSixMonths: boolean;
  isTransferOrganizedByClub: boolean;
};

export enum PaymentFrequency {
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly'
}

export type CrazyMenuDto = {
  name: string;
  price: number;
  reward?: number;
};

export type ConsumationPositionDto = {
  name: string;
  price: number;
  reward?: number;
};

export type PaymentsDto = {
  clubFee: number;
  clubFreeFrequency: PaymentFrequency;
  dailyRateMin: number;
  dailyRateMax: number;
  dailyRatePaymentFrequency: PaymentFrequency;
  guarantee: number;
  guaranteePaymentFrequency: PaymentFrequency;
  full: number;
  deposit: number;
  fullPaymentFrequency: PaymentFrequency;
  topless: number;
  toplessPaymentFrequency: PaymentFrequency;
  goGo: number;
  goGoPaymentFrequency: PaymentFrequency;
  show: number;
  showPaymentFrequency: PaymentFrequency;
  tips: number;
  tipsPaymentFrequency: PaymentFrequency;
  crazyMenu: CrazyMenuDto[];
  consummationItems: ConsumationPositionDto[];
  crazyMenuPercent: number;
  crazyMenuPaymentFrequency: PaymentFrequency;
  consummationFrequency: PaymentFrequency;
};

export enum ConsumationType {
  Active = 'Active',
  Passive = 'Passive'
}

export type WorkingConditionDto = {
  consummationType: ConsumationType;
  choreographerPresence: boolean;
  photoshootMandatory: boolean;
  artistsPerShift: number;
  numberOfStages: number;
  numberOfPolesDynamic: number;
  numberOfPolesStatic: number;
  experienceRequired: boolean;
  artistTraining: boolean;
  dressCodes: string[];
  additionalInformation: string;
};

export type HousingDto = {
  isHousingPaidByClub: boolean;
  utilityFee: number;
  isClubHousingMandatory: boolean;
  peoplePerRoom: number;
  housingPrice: number;
  housingPaymentFrequency: PaymentFrequency;
  isUtilityFeePaidByClub: boolean;
  utilityPaymentFrequency: PaymentFrequency;
};

export type PenaltyItemDto = {
  penaltyItemId: number;
  name: string;
  fine: number;
};

export type PhotoItemDto = {
  id: number;
  title: string | null;
  description: string | null;
  tag: string | null;
  isProfile: boolean;
  filePath: string;
  thumbnailPath: string;
};

export type PhotoUpdateDto = {
  title?: string;
  description?: string;
  tag?: string;
  isProfile?: boolean;
};

export type VideoUpdateDto = {
  title: string;
  description: string;
  tag: string;
  isProfile: boolean;
};

export type ClubRegisterRequestDto = {
  email: string;
  name: string;
  phoneNumber: string;
  howDidYouHearAboutUs: string;
  role: Role;
  clubName: string;
};

export type ArtistRegisterRequestDto = {
  email: string;
  name: string;
  phoneNumber: string;
  howDidYouHearAboutUs: string;
  role: Role;
  dateOfBirth: Date | string;
  hasClubExperience: boolean | null;
};

export type ArtistFullProfileInfoDto = {
  about: string;
  info: ArtistInfoDto;
  languages: ArtistLanguageDto[];
  parameters: ArtistParametersDto;
  photos: PhotoItemDto[];
  status: ArtistProfileStatus;
  videos: VideoItemDto[];
  workExperience: ArtistWorkHistoryDto;
};
export type ClubFullProfileInfoDto = {
  clubInfo: ClubInfoDto;
  contractTerms: ContractTermsDto;
  videos: VideoItemDto[];
  housing: HousingDto;
  payments: PaymentsDto;
  penalties: PenaltyItemDto[];
  photos: PhotoItemDto[];
  schedule: DayScheduleItem[];
  workingConditions: WorkingConditionDto;
};

export type ClubItem = {
  clubProfileId: number;
  email: string;
  chatProfileId: number;
  name: string;
  address: string;
  country: string;
  phone: string;
};

export type ArtistItem = {
  artistProfileId: number;
  email: string;
  chatProfileId: number;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  countryOfResidence: string;
};
export type ActivityItem = {
  userActivityId: number;
  type: string;
  artistProfileId: number;
  clubProfileId: number;
  conversationId: number;
  workRequestId: number | null;
  workInviteId: number | null;
  timestamp: string;
  artistName: string;
  clubName: string;
  code: string;
};
export type FullActivityItem = {
  workItemType: WorkItemTypes;
  workItemId: number;
  artistProfileId: number;
  clubProfileId: number;
  status: WorkItemStatus;
  artistEmail: string;
  clubEmail: string;
  artistChatProfileId: number;
  clubChatProfileId: number;
  artistName: string;
  artistPhoto: string;
  clubName: string;
  clubPhoto: string;
  artistCountry: string;
  artistPhoneNumber: string;
  clubPhoneNumber: string;
  clubAddress: string;
  clubCountry: string;
  startDate: string;
  endDate: string;
  newEndDate: string | null;
  arrivalConfirmed: boolean;
  ticketCreditation: boolean;
  approvedByArtist: boolean;
  approvedByClub: boolean;
  artistRequestedEndDate: boolean;
  jobRole: ArtistJobs;
};

export enum ResponsCategory {
  pending = 'pending',
  accepted = 'accepted',
  contractOngoing = 'contractOngoing',
  clubSetEndDate = 'clubSetEndDate',
  artistRequestedEndDate = 'artistRequestedEndDate',
  completed = 'completed',
  notSuccessful = 'notSuccessful'
}

export type CategorisedResponse = {
  [key in ResponsCategory]: FullActivityItem[];
};

export enum RequestRegistrationStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected'
}

export type RequestRegistrationItem = {
  id: number;
  name: string;
  clubName: string;
  email: string;
  phoneNumber: string;
  howDidYouHearAboutUs: string;
  status: RequestRegistrationStatus;
  createdAt: string;
};
